<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <div class="seatch">
     
      <div>
        <span>parameter:</span> <input type="text" v-model="parameter" />
      </div>
      <div><span>token:</span> <input type="text" v-model="token" /></div>
      <div><span>url:</span> <input type="text" v-model="url" /></div>
      <div>
        <span>userAgent:</span> <input type="text" v-model="userAgent" />
      </div>
      <div><span>headers:</span> <input type="text" v-model="headers" /></div>
       <div>
        <span>url:</span> <input type="text" />
      </div>
      
      <div style="margin-top: 10px ">
          <el-date-picker
            v-model="startTimeStr"
            type="datetime"
            :size="inputSize"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="selectStartTime"
            placeholder="开始日期" style="width: 200px;">
          </el-date-picker>

          <el-date-picker
            v-model="endTimeStr"
            type="datetime"
            :size="inputSize"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="selectEndTime"
            placeholder="结束日期" style="width: 200px">
          </el-date-picker>
      </div>
      <div style="margin-top:10px; ">
        <span class="el-icon-search" @click="getWebLogList"></span>
      </div>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 10px; text-align: center"
      >
        <!--          :max-height="tableHeight?tableHeight:0"-->
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :fixed="col.fixed"
          :width="col.width"
          :type="col.type"
          :min-width="col.minwidth"
          v-for="(col, index) in listCol"
          :key="index"
        >
        </el-table-column>
      </el-table>

      <div style="margin: 20px 0 80px 0; text-align: center">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 70, 100]"
          :page-size="pageSize"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      inputSize:"medium",
      tableHeight: 50,
      color: "#5DC5B8",
      current: "公司后台",
      currentPage: 1,
      pageSize: 10,
      total: 10,
      id: "",
      url: "",
      parameter: "",
      token: "",
      userAgent: "",
      headers: "",
      startTimeStr: "",
      endTimeStr: "",
      defaultProps: {
        //  列  :  显示的值
        date: "date",
        name: "name",
        address: "address",
      },
      tableData: [
      ], //列表数据
      emptyText: "",
      //表格高度
      listCol: [
        {
          prop: "orderNum",
          label: "序号",
          width: "100",
          fixed: true,
          type: "index",
        },

        {
          prop: "id",
          label: "id",
          minwidth: "100",
          height: "120",
        },
        {
          prop: "httpMethod",
          label: "请求方式",
          minwidth: "90",
        },
        {
          prop: "startTime",
          label: "startTime",
          minwidth: "100",
        },

        {
          prop: "token",
          label: "token",
          minwidth: "200",
        },
        {
          prop: "resultText",
          label: "resultText",
          width: "200",
        },
        {
          prop: "classMethod",
          label: "classMethod",
          minwidth: "200",
        },
        {
          prop: "headers",
          label: "headers",
          minwidth: "200",
        },
        {
          prop: "ip",
          label: "ip",
          minwidth: "100",
        },
        {
          prop: "userAgent",
          label: "userAgent",
          minwidth: "200",
        },
        {
          prop: "responseStatus",
          label: "responseStatus",
          minwidth: "100",
        },

        {
          prop: "url",
          label: "url",
          minwidth: "150",
        },
        {
          prop: "parameter",
          label: "parameter",
          minwidth: "130",
        },
      ],
    };
  },
  mounted() {
    this.getWebLogList();
  },
  methods: {
    selectStartTime(val){
      this.startTimeStr = val
      console.log(this.startTimeStr)
      console.log('-------------')
    },
    selectEndTime(val){
      this.endTimeStr = val
      console.log(this.endTimeStr)
    },

    changePageSize(val) {
      this.pageSize = val;
      this.getWebLogList();
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      this.getWebLogList();
    },

    getWebLogList() {
      let _this = this;
      let params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        url: _this.url,
        parameter: _this.parameter,
        token: _this.token,
        userAgent: _this.userAgent,
        headers: _this.headers,
        startTimeStr: _this.startTimeStr,
        endTimeStr: _this.endTimeStr,
      };
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 800 + "px";
        http.get(apiData.webLogList, true, params, (res) => {
          if (res.data.code == 200) {
            console.log(res.data.data.page.list)
            _this.tableData = res.data.data.page.list;
            _this.startTimeStr = res.data.data.startTimeStr
            _this.endTimeStr = res.data.data.endTimeStr
            _this.total = res.data.data.totalRow;
            //  _this.$message.success(res.data.msg);
          } else {
            _this.$message.error(res.data.msg);
          }
        });
      });
    },
  },
};
</script>
<style slot-scope lang="less">
.b {
  margin: 0 10px;
}
.titleBox {
  margin: 20px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.zitiyangshi {
  color: #5dc5b8;
  background: red;
}
.seatch-name {
  text-align: left;
  display: flex;
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  .el-icon-search {
    font-size: 20px;
    display: block;
    padding: 5px 0 0 5px;
  }
}
.zitiyaoshi {
  color: #5dc5b8;
}
.el-table-column {
  color: #5dc5b8;
  background: red;
}
.blue {
  color: #5dc5b8;
}
.seatch {
  width: 100%;
  height: 30px;
  div {
    float: left;
    margin-right: 10px;
  }
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  select {
    width: 120px;
    height: 30px;
    margin-left: 5px;
    margin-right: 10px;
  }
.el-icon-search {
    font-size: 20px;
    margin-top: 6px;
  }
  .el-form-item{
    width: 300px;
  }
  .el-input--medium .el-input__inner{
    width: 100%;
    height: 30px;
  }
  .el-input--medium .el-input__icon {
    line-height: 30px;
  }

}
</style>